<template>
    <div v-if="loadingType" class="loading main-bg-color">
    <div class="logo">
        <img class="img-contain" src="@/assets/logo2.png" alt="">
    </div>
    <div class="border-box1"></div>
    <div class="border-box2"></div>
    </div>
</template>

<script>

export default {
    name: 'Loading',
    data() {
        return {
            loadingType: true
        }
    },
    mounted() {
        setTimeout(() => {
            this.loadingType = false
        }, 2000)
    }
}


</script>

<style lang="less" scoped>

.loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1200;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    background-color: #3e4037;
    .logo{
    width: 15vw;
    height: 20vh;
    }
    .border-box1 {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 4px solid #666b50;
    border-right: 4px solid #666b50;
    left: -5px;
    top: calc(35% + 5px);
    animation: grow-border1 2s ease-in-out forwards;
    }
    .border-box2 {
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 4px solid #666b50;
    border-left: 4px solid #666b50;
    right: -5px;
    bottom: calc(35% + 5px);
    animation: grow-border2 2s ease-in-out forwards;
    }
    @keyframes grow-border1 {
    0% {
        width: 0;
        height: 0;
    }
    25% {
        width: 57%;
        height: 0%;
    }
    50% {
        width: 57%;
        height: 65%;
    }
    75% {
        width: 57%;
        height: 65%;
        opacity: 1;
    }
    100% {
        width: 57%;
        height: 65%;
        opacity: 0;
    }
    }

    @keyframes grow-border2 {
    0% {
        width: 0;
        height: 0;
    }
    25% {
        width: 57%;
        height: 0%;
    }
    50% {
        width: 57%;
        height: 65%;
    }
    75% {
        width: 57%;
        height: 65%;
        opacity: 1;
    }
    100% {
        width: 57%;
        height: 65%;
        opacity: 0;
    }
    }


    // 移动端

    @keyframes grow-border1-phone {
    0% {
        width: 0;
        height: 0;
    }
    25% {
        width: 70%;
        height: 0%;
    }
    50% {
        width: 70%;
        height: 60%;
    }
    75% {
        width: 70%;
        height: 60%;
        opacity: 1;
    }
    100% {
        width: 70%;
        height: 60%;
        opacity: 0;
    }
    }

    @keyframes grow-border2-phone {
    0% {
        width: 0;
        height: 0;
    }
    25% {
        width: 70%;
        height: 0%;
    }
    50% {
        width: 70%;
        height: 60%;
    }
    75% {
        width: 70%;
        height: 60%;
        opacity: 1;
    }
    100% {
        width: 70%;
        height: 60%;
        opacity: 0;
    }
    }
}


@media screen and (max-width:800px) {

    .border-box1{
      top: calc(40% + 5px) !important;
      animation: grow-border1-phone 2s ease-in-out forwards !important;
    }
    .border-box2{
      bottom: calc(40% + 5px) !important;
      animation: grow-border2-phone 2s ease-in-out forwards !important;
    }
    .logo{
      width: 80px;
    }

}

</style>





